import { Typography } from '@mui/material'
import tw from 'twin.macro'
import { ContractorPortalPublicWrapper } from 'src/components/layout/contractorPortal/ContractorPortalPublicWrapper'
import { EnterCodeForm } from 'src/components/auth/enter-code-form/EnterCodeForm'
import { Navigate, useLocation, useNavigate } from 'react-router-dom'
import { useCallback, useMemo } from 'react'
import { CONTRACTOR_PORTAL_ROUTES } from 'src/constants/routes'
import { ChevronLeftMinor } from '@shopify/polaris-icons'
import { Button } from 'src/components/shared/Button'

export const ContractorPortalEnterCodePage = () => {
  const location = useLocation()
  const navigate = useNavigate()

  const phone = useMemo(() => location?.state?.phone || '****', [location])
  const partnerName = useMemo(() => location?.state?.partnerName, [location])

  const handleBack = useCallback(() => {
    navigate(CONTRACTOR_PORTAL_ROUTES.SELECT_PARTNER_URL)
  }, [])

  if (!location?.state?.phone) {
    return <Navigate to={CONTRACTOR_PORTAL_ROUTES.NOT_FOUND_URL} />
  }

  return (
    <ContractorPortalPublicWrapper>
      <Button
        color="light"
        leftIcon={<ChevronLeftMinor width={19} css={tw`fill-primary-500`} />}
        onClick={handleBack}
        size="medium"
      >
        Back
      </Button>
      <Typography variant="h2" css={tw`mb-2 mt-6`}>
        Enter the verification code we just sent.
      </Typography>
      <Typography css={tw`mb-6 text-shades-400`}>
        {`Code has been sent to number ending ${phone.slice(-4)}`}
      </Typography>
      <EnterCodeForm platform="contractorPortal" phone={phone} partnerName={partnerName} />
    </ContractorPortalPublicWrapper>
  )
}
